/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FC, ReactNode } from "react";

type Row = {
  label: string;
  value: ReactNode;
};

type Props = {
  rows: readonly Row[];
};

export const DetailsTable: FC<Props> = ({ rows }) => {
  const classes = styles();

  return (
    <dl css={classes.root}>
      {rows.map(({ label, value }) => (
        <div key={label} css={classes.row}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
};

const styles = () => {
  return {
    root: css`
      margin: 0;
      border: 1px solid #a3a3a3;
    `,
    row: css`
      display: grid;
      grid-template-columns: 96px minmax(0, 1fr);
      align-items: center;
      gap: 12px;
      min-height: 48px;
      padding: 10px 12px;
      & + & {
        border-top: 1px solid #f0f0f0;
      }
      dt {
        color: #5c5c5c;
        font-size: 14px;
        line-height: 1.5;
      }
      dd {
        display: grid;
        gap: 2px;
        margin: 0;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.5;
        text-align: right;
      }
      @media screen and (min-width: 768px) {
        grid-template-columns: 160px minmax(0, 1fr);
        padding: 12px 16px;
      }
    `,
  };
};
